






































































import Vue from 'vue';
import { mapActions as mapRootActions } from 'vuex';
import { BButton, BDropdown, BDropdownItem, BFormInput } from 'bootstrap-vue';

import { mapActions, mapGetters } from '@/state/modules/survey_builder';
import { ModalSize } from '@/components/zen_modal/types';

import MainLayout from './components/MainLayout.vue';
import QuestionList from './components/QuestionList.vue';
import QuestionEdit from './components/QuestionEdit.vue';
import Settings from './components/Settings.vue';
import Preview from './components/Preview.vue';

export default Vue.extend({
  name: 'SurveyBuilder',
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    BFormInput,

    MainLayout,
    QuestionList,
    QuestionEdit,
    Settings,
    Preview,
  },
  computed: {
    ...mapGetters([
      'isLoaded',
      'isSaving',
      'canSave',
      'isDirty',
      'canReset',
      'isPreviewVisible',
      'title',
      'isTitleValid',
      'isEditingQuestion',
    ]),
  },
  watch: {
    isPreviewVisible: function() {
      const pageTitleConfig = this.isPreviewVisible
        ? { title: 'Preview' }
        : {
            title: 'Edit',
            backLink: { label: 'Questionnaire Templates', url: this.getListingUrl() },
          };

      this.setPageTitle(pageTitleConfig);
    },
  },
  created() {
    const surveyId = this.$route.params.surveyId;
    this.init(surveyId);

    this.setPageTitle({
      title: 'Edit',
      backLink: { label: 'Questionnaire Templates', url: this.getListingUrl() },
    });

    this.changeModalSize(ModalSize.Small);

    window.onbeforeunload = () => {
      if (this.isDirty) {
        return true;
      }
      return undefined;
    };
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  methods: {
    ...mapRootActions(['setPageTitle']),
    ...mapRootActions({
      changeModalSize: 'modals/changeSize',
    }),
    ...mapActions(['init', 'reset', 'save', 'saveCopy', 'showPreview', 'hidePreview', 'setTitle']),
    getListingUrl(): string {
      // TODO: Temp until we move the listing page to the SPA. After, we will use the Vue router.
      const referrer = document.referrer;
      const url = '/sor/listing/questionnaire-templates';

      // Preserves SurveyTemplate listing page state (filters, page...) if navigation came from
      // the listing page. Otherwise, returns the default URL.
      return referrer.includes(url) ? referrer : url;
    },
  },
});
